import * as ReactContextMenu from '@radix-ui/react-context-menu'

export const ContextMenuContainer = ReactContextMenu.Root
